export function addCurrent(sla) {
    return {
        type: 'ADD_CURRENT',
        sla,
    }
}
